import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const SLTitleSmall = () => (
  <Wrapper>
    <svg width="98px" height="38px" viewBox="0 0 98 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Broker-Portal---Dashboard---Loading" transform="translate(-276.000000, -683.000000)" fill="#F1F1F4">
              <g id="label+value3" transform="translate(276.000000, 683.000000)">
                  <rect id="Label" x="0" y="0" width="98" height="10"/>
                  <rect id="Value" x="0" y="22" width="64" height="16"/>
              </g>
          </g>
      </g>
    </svg>
  </Wrapper>
)

export default SLTitleSmall
